import React from "react";
import PropTypes from "prop-types";
import userStore from "../../data/userStore";
import Dispatcher from "../../Dispatcher";
import OverActions from "../../data/OverActions";

const STORAGE_KEY = `ao:whoami:${window.location.pathname}`;

const OVER_KEY = `WHO_I_AM_CHANGED_${Math.random().toString().substr(2)}`;

const buildReloadPayload = message => ({
    type: OverActions.SHOW,
    options: {
        key: OVER_KEY,
        message,
        actions: [ {
            label: "Ok",
            callback: () => {
                window.location.hash = ""; //  kludge to remove any path, as it'll be invalid w/ new org
                window.location.reload();
            },
        } ],
    },
});

function readNewValue(e) {
    if (!e.newValue) return e.newValue;
    try {
        return JSON.parse(e.newValue);
    } catch (err) {
        console.error(
            `error parsing new ${STORAGE_KEY} value`,
            err,
            e.newValue,
        );
    }
    return undefined;
}

export default function WhoAmIListener(whoami) {
    // write it down
    React.useEffect(() => {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(whoami));
    }, [whoami.user, whoami.org]);

    // monitor for changes
    React.useEffect(() => {
        const handler = e => {
            if (e.key !== STORAGE_KEY) return;
            const next = readNewValue(e);
            if (!next) return;
            let payload;
            if (whoami.user !== next.user) {
                payload = buildReloadPayload(`You changed users; reload as '${next.user}'.`);
            } else if (whoami.org !== next.org) {
                const newOrg = userStore.getAllOrgs()
                    .find(it => it.key === next.org);
                const label = (newOrg || {}).name || next.org;
                payload = buildReloadPayload(`You changed organizations; reload as '${label}'.`);
            } else {
                payload = {
                    type: OverActions.HIDE,
                    key: OVER_KEY,
                };
            }
            Dispatcher.dispatch(payload);
        };
        window.addEventListener("storage", handler);
        return () =>
            window.removeEventListener("storage", handler);
    }, []);

    return null;
}

WhoAmIListener.propTypes = {
    user: PropTypes.string.isRequired,
    org: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./app/lib/whoami/WhoAmIListener.js